// extracted by mini-css-extract-plugin
export var emptyState = "empty-state-module--empty-state--bOt+b";
export var icon = "empty-state-module--icon--qy1SC";